export default __webpack_public_path__ + "static/media/card_c.4270a476.png";